import React from "react";
import Layout from "../../components/shared/Layout/Layout";
import { SubjectList } from "../../components/SubjectList";

const SubjectListPage = () => {
  return (
    <div
      className="bg_dark"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Layout title="Subjects">
        <SubjectList />
      </Layout>
    </div>
  );
};

export default SubjectListPage;
